export default __webpack_public_path__ + "static/media/002-pisa tower.17391194.svg";